import { useCallback } from 'react';
import { load as loadZipy, init as initZipy } from '@mindtickle/ui-shell-core/Zipy';

import type { TLocalAuthContext } from '~/components/Auth';

function useZipy(auth?: TLocalAuthContext) {
  const user = auth?.user;
  const company = auth?.company;
  const isZipyEnabledForCompany = auth?.featureToggles.isZipyEnabled;

  const init = useCallback(async () => {
    if (user?.id && company?.id && isZipyEnabledForCompany) {
      await loadZipy();
      await initZipy(user.id!, {
        email: user?.email,
        'Learning Site': company.learningSite!,
        cname: company.id!,
      });
    }
  }, [company?.id, company?.learningSite, isZipyEnabledForCompany, user?.id]);

  return {
    init,
  };
}

export default useZipy;
